import * as React from 'react';

import { $materialsPhase } from '@rematter/modules/brokerage/_state/brokeredLoadDetail.state';
import { Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useSetAtom } from 'jotai/react';
import { LucideMonitor, LucideTruck } from 'lucide-react';

import { useTranslations } from '~/modules/brokerage/i18n/useTranslations';

export type MaterialsPhase = 'Requested' | 'Shipped';

type LoadPhaseToggleProps = {
  initialValue: MaterialsPhase;
};

export const LoadPhaseToggle: React.FC<LoadPhaseToggleProps> = ({
  initialValue,
}) => {
  const t = useTranslations();

  const setActivePhase = useSetAtom($materialsPhase);

  const handleViewModeChange = React.useCallback(
    (selection: Set<React.Key>) => {
      const keys = Array.from(selection.values());
      if (keys.length > 0) {
        setActivePhase(keys[0] as MaterialsPhase);
      }
    },
    [setActivePhase],
  );

  return (
    <ToggleButtonGroup
      selectionMode="single"
      selectedKeys={[initialValue]}
      onSelectionChange={handleViewModeChange}
      className="@LoadPhaseToggle"
    >
      <Toggle id="Requested">
        <div className="flex flex-row items-center gap-2">
          <LucideMonitor className="size-4" strokeWidth={1.5} />
          {t.brokerage.loads.detail.materials.phases.requested}
        </div>
      </Toggle>
      <Toggle id="Shipped">
        <div className="flex flex-row items-center gap-2">
          <LucideTruck className="size-4" strokeWidth={1.5} />
          {t.brokerage.loads.detail.materials.phases.shipped}
        </div>
      </Toggle>
    </ToggleButtonGroup>
  );
};
